import React from 'react';
import { replaceAllComplex } from '../../../../mol_function';

export { default as facebookIMG } from './Parts/images/icon-facebook.svg';
export { default as twitterIMG } from './Parts/images/icon-twitter.svg';
export { default as pinterestIMG } from './Parts/images/icon-pinterest.svg';
export { default as informationIMG } from './Parts/images/icon-artikel-information.svg';

export function getKalenderSubtitel(
  getProp: (name: string) => any,
  getTittleHtml: () => JSX.Element,
  getTitelzusatzHtml: () => JSX.Element,
) {
  let htmlKalendarium = null;
  let attributeKalendarium = getProp('Kalendarium');
  if (
    attributeKalendarium != null &&
    attributeKalendarium.value != null &&
    attributeKalendarium.value != 'immerwährend'
  ) {
    htmlKalendarium = (
      <a
        href={
          '/Kalendarium/' +
          replaceAllComplex(attributeKalendarium.value, [
            { s: '/', r: '___' },
            { s: '&', r: '_-_' },
            { s: '?', r: '%3F' },
            { s: '!', r: '0_0' },
          ]) +
          '/s/'
        }
        title={'stöbern Sie in ' + attributeKalendarium.value + '.'}
      >
        {attributeKalendarium.value}
      </a>
    );
  }

  let htmlFormat = null;
  let attributeFormat = getProp('Format');
  if (attributeFormat != null && attributeFormat.value != null) {
    htmlFormat = (
      <>
        {htmlKalendarium != null ? ' - ' : null}
        <a
          href={
            '/Format/' +
            replaceAllComplex(attributeFormat.value, [
              { s: '/', r: '___' },
              { s: '&', r: '_-_' },
              { s: '?', r: '%3F' },
              { s: '!', r: '0_0' },
            ]) +
            '/s/'
          }
          title={'stöbern Sie in ' + attributeFormat.value + '.'}
        >
          {attributeFormat.value}
        </a>
      </>
    );
  }

  let htmlKalenderausrichtung = <br />;
  let attributeKalenderausrichtung = getProp('Kalenderausrichtung');
  if (
    attributeKalenderausrichtung != null &&
    attributeKalenderausrichtung.value != null
  ) {
    htmlKalenderausrichtung = (
      <>
        {htmlFormat != null ? ' - ' : null}
        <a
          href={
            '/Kalenderausrichtung/' +
            replaceAllComplex(attributeKalenderausrichtung.value, [
              { s: '/', r: '___' },
              { s: '&', r: '_-_' },
              { s: '?', r: '%3F' },
              { s: '!', r: '0_0' },
            ]) +
            '/s/'
          }
          title={'stöbern Sie in ' + attributeKalenderausrichtung.value + '.'}
        >
          {attributeKalenderausrichtung.value}
        </a>
        <br />
      </>
    );
  }

  return (
    <span className="titel_head">
      {htmlKalendarium}
      {htmlFormat}
      {htmlKalenderausrichtung}
      <span className="titel">{getTittleHtml()}</span>
      <span className="titel_sub">{getTitelzusatzHtml()}</span>
    </span>
  );
}

export function allowKeysAttribute(allkeys: string[]) {
  return allkeys;
}

export function getShopArticleLabelPrefix():string {
  return 'buchbutler';
}
